
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100.72 54.76"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M100.72 5a5 5 0 01-1.49 3.56L53.88 53.32a5 5 0 01-7 0L1.49 8.56a5 5 0 017-7.12l41.88 41.29L92.2 1.44a5 5 0 017.07.05A4.94 4.94 0 01100.72 5z"}})])
          )
        }
      }
    